<template>
    <div v-if="$store.getters.authCheck" class="default d-flex flex-column flex-grow-1">
        <navbar></navbar>
        <portal-target
            name="sticky-header"
            multiple
            :class="['sticky-header sticky-top bg-white', {'shadow': scrolledSticky}]"
            ref="stickyHeader"
        >
        </portal-target>
        <div class="body-wrapper flex-grow-1 d-flex flex-column">
            <keep-alive :include="cachedComponents">
                <router-view></router-view>
            </keep-alive>
        </div>
        <terms-conditions-modal
            v-if="!termsAccepted"
            :show.sync="modals.terms.visible"
        >
        </terms-conditions-modal>
    </div>
</template>

<script>
import Navbar from '@/components/Nav/Navbar';
import TermsConditionsModal from '@/components/Modal/TermsConditionsModal';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';

export default {
  components: {
    Navbar,
    TermsConditionsModal,
    ScrollableWidget,
  },
  data() {
    return {
      cachedComponents: [
        'Programme',
      ],
      modals: {
        terms: {
          visible: false,
        },
      },
      scrolledSticky: false,
    };
  },
  computed: {
    termsAccepted() {
      return this.$store.getters.userAcceptedTerms;
    },
  },
  watch: {
    termsAccepted: {
      handler(newTermsAccepted) {
        if (this.$store.getters.authCheck) {
          this.modals.terms.visible = !newTermsAccepted;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const handleScroll = () => {
      if (window.scrollY > 0 && window.scrollY >= this.$refs.stickyHeader.$el.offsetTop) {
        this.scrolledSticky = true;
      } else {
        this.scrolledSticky = false;
      }
    };

    window.addEventListener('scroll', handleScroll);
    this.$once('hook:destroyed', () => {
      window.removeEventListener('scroll', handleScroll);
    });

    handleScroll();
  },
};
</script>

